<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="miembroForm" [formGroup]="miembroForm" class="tax-type-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <mat-label>{{ "Msisdn" | translate }}*</mat-label>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="phoneNumber" formControlName="phoneNumber" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        @if (isControlValid(miembroForm, "phoneNumber")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(miembroForm, "phoneNumber", "Msisdn") }}
        </div>
        }

        <div class="d-flex justify-content-end align-content-end w-100-p">
            <button class="d-flex justify-content-center align-content-center w-auto" mat-raised-button
                (click)="addVariable()" [disabled]="variables.length >= 8">
                <span class="material-icons-outlined"> add </span>
                <span>
                    {{"addVariable" | translate}}
                </span>
            </button>
        </div>
        <hr>
        <ng-container formArrayName="variables">
            <div class="row" *ngFor="let variable of variables.controls; let i = index">
                <div class="row col-12" [formArrayName]="i">
                    <div class="col-5">
                        <mat-label>{{'variableName'| translate}}</mat-label>
                        <mat-form-field appearance="outline" class="w-100-p">
                            <input matInput name="name" formControlName="name" mat-maxlength="50" placeholder=""
                                [readonly]="action === recordAction.View" />
                        </mat-form-field>
                    </div>

                    <div class="col-5">
                        <mat-label>{{'variableValue'| translate}}</mat-label>
                        <mat-form-field appearance="outline" class="w-100-p">
                            <input matInput name="value" formControlName="value" mat-maxlength="50" placeholder=""
                                [readonly]="action === recordAction.View" />
                        </mat-form-field>
                    </div>
                    <div class="col-2 d-flex gap-2 justify-content-center align-items-center">
                        <button class="add-variable d-flex justify-content-center align-content-center"
                            mat-raised-button (click)="removeVariable(i)" [matTooltip]="'removeVariable' | translate">
                            <span class="material-icons-outlined"> delete </span>
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div>

            </div> -->
        </ng-container>

        <div class="h-100">
            <button *ngIf="action !== recordAction.Update" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="miembroForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-20"> save </span>
                {{ "Guardar" | translate }}
            </button>

            <button *ngIf="action === recordAction.Update" mat-raised-button (click)="performAction()"
                class="save-button" [disabled]="miembroForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-20"> save </span>
                {{ "Guardar" | translate }}
            </button>
        </div>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>